import { AddClassesProps, AddUserProps } from "../../../lib"
import { AddBehaviorCategoryProps } from "../../../lib/Types/BehaviorCategoryProps"
import { AddBehaviorProps, BehaviorProps } from "../../../lib/Types/BehaviorProps"

export const behaviorCategoryInitialValues :AddBehaviorCategoryProps =  {
    name: ""
} 

export const editBehaviorCategoryIntitialValues=(item: any): AddBehaviorCategoryProps=>{

    return {
         name:item?.name 
    }
}


export const behaviorInitialValues :BehaviorProps=  {
    name: "",
    behaviorCategoryId: '',
    id: 0,
    behaviorCategory: {
        id: 0,
        name: ""
    }
} 

export const editBehaviorIntitialValues=(item: any): BehaviorProps=>{

    return {
        id : item.id,
         name:item?.name,
         behaviorCategoryId:`${item?.behaviorCategoryId}`,
         behaviorCategory:{
             id: 0,
             name: item.behaviorCategory.name
         }
    }
}